import React from 'react';
import type { PropsWithChildren } from 'react';

import { Button, Text } from '@change/ds-core-ui';
import type { Icon } from '@change/ds-icons';
import { cn } from '@change/ds-utils';

import { Translate } from '@change-corgi/core-react/i18n';

import { useBannerActions } from './hooks/useBannerActions';

export const BannerActions: React.FC<BannerActionsProps> = ({ icon, title, description, onPrimaryAction }) => {
	const { actions } = useBannerActions({ onPrimaryAction });

	return (
		<div role="note" className="bg-gradient-background-dark-2 text-typography-inverse-strong-fixed py-4">
			<div className="container flex gap-3">
				{React.cloneElement(icon, {
					...icon.props,
					size: 24,
					className: cn(
						icon.props.className,
						'text-typography-inverse-strong-fixed flex min-h-[24px] min-w-[24px] items-center justify-center',
					),
				})}
				<div className="flex flex-col gap-4">
					<div className="flex flex-col md:block md:space-x-2">
						<Text variant="body" size="large" fontWeight="bold">
							{title}
						</Text>
						<Text variant="body">{description}</Text>
					</div>
					<div className="flex gap-2">
						<Button
							onClick={() => actions.transitionToPreview()}
							variant="secondary-inverse"
							size="x-small"
							data-qa="banner-actions-primary-action"
							type="button"
						>
							<Translate value="corgi.start_a_petition.create.banner_actions.action_buttons.preview" />
						</Button>
					</div>
				</div>
			</div>
		</div>
	);
};

type BannerActionsProps = PropsWithChildren<{
	title: React.ReactElement;
	description: React.ReactElement;
	onPrimaryAction: () => void;
	icon: React.ReactElement<Icon>;
}>;
